import classNames from 'classnames'
import { prepareAppealToProductDelete } from 'feature/appeals/helpers/prepareAppealToProductDelete'
import { stateCurrentAppeal } from 'feature/appeals/redux/appealFormCreateSelector'
import { useEditAppealMutation } from 'feature/appeals/redux/appeals.api'
import { TAppeal, TProduct } from 'feature/appeals/type'
import { removeModalScrollSafari } from 'helpers/removeModalScrollSafari'
import { useSetNotice } from 'hooks/useSetNotice'
import { useEffect, useState } from 'react'
import { useActions, useAppSelector } from 'store/hooks'
import { LoaderInCentalPosition } from 'widget'
import { Severity } from 'widget/Notifications'

import { EditModalsList } from './EditModalsList/EditModalsList'
import style from './OrderInformationBlock.module.scss'
import { OrderLocation } from './OrderLocation/OrderLocation'
import { OrderTime } from './OrderTime/OrderTime'
import { ProductInformation } from './ProductInformation/ProductInformation'

type TOrderInformationBlock = {
  data: TAppeal
  isEdit?: boolean
  timeSlotText: string
}

export type TModalsType = 'address' | 'time' | 'params' | 'delete'

//  состав заявки

export function OrderInformationBlock({
  data,
  timeSlotText,
  isEdit = false,
}: TOrderInformationBlock) {
  const [isEditProductModalOpen, setEditProductModalOpen] =
    useState<boolean>(false)
  const [isEditAddressModalOpen, setEditAddressModalOpen] =
    useState<boolean>(false)
  const [isEditSlotsModalOpen, setEditSlotsModalOpen] = useState<boolean>(false)
  const [isDeleteModalOpen, setDeleteModalOpen] = useState<boolean>(false)
  const [editableProduct, setEditableProduct] = useState<TProduct | null>(null)
  const [deletedProduct, setDeletedProduct] = useState<TProduct | null>(null)
  const appeal = useAppSelector(state => state.newAppeal)
  const [isDeleteButtonLoading, setDeleteButtonLoading] = useState<boolean>()
  const [editAppeal] = useEditAppealMutation()
  const { location, products, timeSlots } = data
  const { setClickMarkCoords, setIsPullingStopped } = useActions()
  const setNotice = useSetNotice()
  const { editAppealLoading } = useAppSelector(stateCurrentAppeal)

  useEffect(() => {
    setClickMarkCoords([+location.geoLat, +location.geoLon])
  }, [])

  const handleCloseManageModal = () => {
    setEditProductModalOpen(false)
    setEditAddressModalOpen(false)
    setEditSlotsModalOpen(false)
    setDeleteModalOpen(false)
    removeModalScrollSafari(false)
    setIsPullingStopped(false)
  }

  const openModal = (type: TModalsType, product?: TProduct) => {
    removeModalScrollSafari(true)
    setIsPullingStopped(true)

    switch (type) {
      case 'address':
        setEditAddressModalOpen(true)
        return
      case 'delete':
        setDeleteModalOpen(true)
        if (product) setDeletedProduct(product)
        return
      case 'time':
        setEditSlotsModalOpen(true)
        return
      case 'params':
        setEditProductModalOpen(true)
        if (product) setEditableProduct(product)
        return
    }
  }
  const checkIsModalOpen = (type: TModalsType): boolean => {
    const isModalOpen = {
      address: isEditAddressModalOpen,
      delete: Boolean(deletedProduct?.name.length) && isDeleteModalOpen,
      time: isEditSlotsModalOpen,
      params: isEditProductModalOpen,
    }
    return isModalOpen[type]
  }

  const handleProductDelete = () => {
    if (!appeal.products?.length) return
    setDeleteButtonLoading(true)

    editAppeal(prepareAppealToProductDelete(products, deletedProduct, appeal))
      .then(res => {
        if ('error' in res) {
          //@ts-ignore
          const error = res.error.data
          setNotice(error.message, Severity.error)
          setDeleteButtonLoading(false)
          return
        }

        setNotice(res.data.message, Severity.success)
        setDeleteButtonLoading(false)
        handleCloseManageModal()
      })
      .catch(error => {
        setNotice(error.data, Severity.error)
        setDeleteButtonLoading(false)
        handleCloseManageModal()
      })
  }

  return (
    <section className={style.content}>
      {editAppealLoading.appealInformation && (
        <LoaderInCentalPosition className={style.loader} />
      )}

      <div
        className={classNames(
          style.orderInformationSection,
          editAppealLoading.appealInformation && style.hidden,
        )}
      >
        {!!products.length && (
          <div className={style.productsList}>
            {products.map((product: TProduct) => (
              <ProductInformation
                product={product}
                key={product.id}
                isEdit={isEdit}
                canDelete={products.length > 1 && isEdit}
                openModal={openModal}
              />
            ))}
          </div>
        )}
        <div className={style.informationBlocks}>
          <OrderLocation
            isEdit={isEdit}
            isEditAddressModalOpen={isEditAddressModalOpen}
            openModal={openModal}
            location={location}
          />

          {!!timeSlots?.length && (
            <OrderTime
              isEdit={isEdit}
              openModal={openModal}
              timeSlotText={timeSlotText}
              timeSlots={timeSlots}
            />
          )}
        </div>
      </div>

      {isEdit && (
        <EditModalsList
          timeSlotTitle={
            data.type === 'SERVICE'
              ? 'Дата и время диагностики'
              : 'Дата и время замера'
          }
          checkIsModalOpen={checkIsModalOpen}
          deletedProduct={deletedProduct}
          handleProductDelete={handleProductDelete}
          isDeleteButtonLoading={isDeleteButtonLoading}
          location={location}
          timeSlots={timeSlots}
          editableProduct={editableProduct}
          handleCloseManageModal={handleCloseManageModal}
        />
      )}
    </section>
  )
}
